module.exports = __webpack_public_path__ + "img/led_in_switch_80_no_led.23480988.png";